import Spinner from 'app/components/Spinner';
import WithCondition from 'app/hoc/WithCondition';
import { setUserInfo } from 'app/utils';
import { refreshToken } from 'app/utils/refreshToken';
import { setSessionLogger } from 'app/utils/sessionLogger';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import PrivateLayoutBackdrop from '../PrivateLayoutBackdrop';

const PrivateLayout = () => {
  const accessToken = useSelector(({ user }) => user.accessToken);

  useEffect(() => {
    if (!accessToken) {
      refreshToken().then(() => {
        setUserInfo();
        setSessionLogger();
      });
    }
  }, []);

  return (
    <WithCondition
      when={accessToken}
      then={
        <>
          <Outlet />
          <PrivateLayoutBackdrop />
        </>
      }
      or={<Spinner />}
    />
  );
};

export default PrivateLayout;
